import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GraduationCap } from "lucide-react";

export default function ChildrenPage() {
  const [students, setStudents] = useState([]);
  useEffect(() => { api.get("/students").then(({ data }) => setStudents(data)); }, []);

  return (
    <div className="space-y-5" data-testid="page-children">
      <h2 className="font-heading text-3xl font-extrabold text-[#1E3A8A] tracking-tight">Mes enfants</h2>
      <div className="grid md:grid-cols-2 gap-4">
        {students.map((s) => (
          <div key={s.id} className="bg-white border border-slate-200 rounded-xl p-5 flex gap-4" data-testid={`child-detail-${s.id}`}>
            <div className={`w-16 h-16 rounded-full flex items-center justify-center text-white text-xl font-bold flex-shrink-0 ${s.gender === "M" ? "bg-[#1E3A8A]" : "bg-[#EA580C]"}`}>{s.first_name[0]}{s.last_name[0]}</div>
            <div className="flex-1">
              <div className="font-heading font-bold text-xl text-[#0F172A]">{s.first_name} {s.last_name}</div>
              <div className="text-sm text-slate-600 mt-1">{s.class_name}</div>
              <div className="text-xs text-slate-500 mt-2">Né(e) le {s.birth_date} · {s.gender === "M" ? "Garçon" : "Fille"}</div>
              <div className="mt-3 inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-green-100 text-green-800">
                <GraduationCap className="h-3 w-3" /> Actif
              </div>
            </div>
          </div>
        ))}
        {students.length === 0 && <div className="col-span-2 text-center text-slate-500 py-8 bg-white rounded-xl border border-slate-200">Aucun enfant inscrit</div>}
      </div>
    </div>
  );
}
